export default function UserViewDetailsController(
  $scope,
  $state,
  $stateParams,
  $rootScope,
  $uibModal,
  usersService,
  gettextCatalog,
) {
  'ngInject';

  $scope.key = $stateParams.key;
  $scope.onLoadErrorFlag = false;
  $scope.onLoadErrorText = '';
  $scope.successFlag = false;
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.loading = true;
  $scope.roles = [];
  $scope.existingRoles = [];
  $scope.changes = [
    { op: 'add', roles: [] },
    { op: 'remove', roles: [] },
  ];
  $scope.userId = $stateParams.userId;
  var currentUser = $rootScope.currentUser;
  $scope.isSelf = false;

  //Scope functions
  var refresh = function () {
    usersService.getUser($stateParams.userId).then(
      function (response) {
        $scope.successFlag = $stateParams.success;
        $scope.user = response.data;
        if (!$state.current.ncyBreadcrumbLabel) {
          $state.current.ncyBreadcrumbLabel = $scope.user.name;
        }
        $scope.firstName = $scope.user.claims.data.firstName;
        $scope.lastName = $scope.user.claims.data.lastName;

        $scope.roles = response.data.roles;
        $scope.groups = response.data.groups;
        $scope.loading = false;
        if ($scope.user.id === currentUser.id) {
          $scope.isSelf = true;
        }
        $scope.$emit('$viewContentLoaded'); //breadcrumb fix;
      },
      function (error) {
        $scope.loading = false;
        $scope.user = null;
        if (!$state.current.ncyBreadcrumbLabel) {
          if ($scope.$parent.selectedName) {
            $state.current.ncyBreadcrumbLabel = $scope.$parent.selectedName;
          } else {
            $state.current.ncyBreadcrumbLabel = 'Error';
          }
        }
        var errorMsg = gettextCatalog.getString(
          'An error occurred while retrieving user information',
        );
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.onLoadErrorFlag = true;
        $scope.onLoadErrorText = errorMsg;
      },
    );
  };

  if (currentUser) {
    refresh();
  }

  $rootScope.$watch('currentUser', function (newVal, oldVal) {
    if (newVal && !oldVal) {
      currentUser = $rootScope.currentUser;
      refresh();
    }
  });

  $scope.toTitleCase = function (input) {
    input = input || '';
    return input.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  $scope.removeButtonPressed = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      template: require('./delete-modal/_delete.modal.html'),
      controller: 'UserViewDeleteModalController',
      backdropClass: 'tr-user-remove-dismiss',
      resolve: {
        user: function () {
          return $scope.user;
        },
      },
      size: 'md',
    });
    //modalInstance.catch(function () {});
  };
}
